<template>
    <div class="card-more-dropdown" @mouseleave="closeDropdownDelayed">
        <more-circle @click="openDropdown" class="transparent" />
        <transition name="fade">
            <div class="dropdown" v-if="open" @mouseenter="openDropdown" @mouseleave="closeDropdown">
                <div class="item" @click="muteWord" v-if="!hideMuteButton">
                    <mute-icon />
                    <span class="text" v-html="this.$i18n('mute_word_button_label')" />
                </div>
                <div class="item" @click="toggleFavouriteWord">
                    <template v-if="wordIsFavourite">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.6066 4C2.8016 4 0.395245 9.80946 3.7929 13.2071L11.2929 20.7071C11.4804 20.8946 11.7348 21 12 21C12.2652 21 12.5196 20.8946 12.7071 20.7071L20.2071 13.2071C23.6048 9.80945 21.1984 4 16.3934 4C14.5813 4 12.978 4.89365 12 6.26428C11.022 4.89365 9.41868 4 7.6066 4Z" fill="#AC6ED1"/>
                        </svg>
                        <span class="text" v-html="this.$i18n('remove_favorite_word_button_label')" />
                    </template>
                    <template v-else>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9999 20L11.2928 20.7071C11.4804 20.8946 11.7347 21 11.9999 21C12.2652 21 12.5195 20.8946 12.7071 20.7071L11.9999 20ZM4.49995 12.5L5.20706 11.7929L4.49995 12.5ZM10.9999 9.3934C10.9999 9.94568 11.4477 10.3934 11.9999 10.3934C12.5522 10.3934 12.9999 9.94568 12.9999 9.3934H10.9999ZM19.5 12.5L18.7928 11.7929V11.7929L19.5 12.5ZM10.8321 17.4179C10.4415 17.0274 9.80837 17.0274 9.41784 17.4179C9.02732 17.8084 9.02732 18.4416 9.41784 18.8321L10.8321 17.4179ZM5.66784 15.0821C6.05837 15.4726 6.69153 15.4726 7.08206 15.0821C7.47258 14.6916 7.47258 14.0584 7.08206 13.6679L5.66784 15.0821ZM7.60655 6C9.48067 6 10.9999 7.51928 10.9999 9.3934H12.9999C12.9999 6.41471 10.5852 4 7.60655 4V6ZM7.60655 4C2.80154 4 0.395193 9.80946 3.79284 13.2071L5.20706 11.7929C3.06933 9.65517 4.58336 6 7.60655 6V4ZM18.7928 11.7929L11.2928 19.2929L12.7071 20.7071L20.2071 13.2071L18.7928 11.7929ZM16.3933 6C19.4165 6 20.9306 9.65517 18.7928 11.7929L20.2071 13.2071C23.6047 9.80945 21.1984 4 16.3933 4V6ZM16.3933 4C13.4147 4 10.9999 6.41471 10.9999 9.3934H12.9999C12.9999 7.51928 14.5192 6 16.3933 6V4ZM12.7071 19.2929L10.8321 17.4179L9.41784 18.8321L11.2928 20.7071L12.7071 19.2929ZM7.08206 13.6679L5.20706 11.7929L3.79284 13.2071L5.66784 15.0821L7.08206 13.6679Z" fill="#2C3143"/>
                        </svg>
                        <span class="text" v-html="this.$i18n('favorite_word_button_label')" />
                    </template>
                </div>
                <div class="item" @click="openReportModal">
                    <report-icon />
                    <span class="text" v-html="this.$i18n('card_feedback_report_problem_title')" />
                </div>
                <div class="item" @click="openHotkeysModal">
                    <help-icon />
                    <span class="text" v-html="this.$i18n('guess_game_overflow_menu_hotkeys_btn')" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import MoreCircle from 'Images/more-circle.svg';

    import VButton from "ViewComponent/v-button.vue";
    import MuteIcon from 'Images/mute-24x24.svg';
    import ReportIcon from 'Images/report-24x24.svg';
    import HelpIcon from 'Images/help-24x24.svg';
    import { EventBus } from "Util/vue-event-bus";

    export default {
        name: 'more-dropdown',
        components: {
            VButton,
            MoreCircle,
            MuteIcon,
            ReportIcon,
            HelpIcon
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            variation: {
                type: Object
            },
            variationToggleDisabled: {
                type: Boolean,
                default: false
            },
            transparent: {
                type: Boolean,
                default: true
            },
            on_previous: {
                type: Boolean,
                default: false
            },
            wordIsFavourite: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            isEditable() {
                return (this.variation && this.variation.type === 'lesson' && this.variation.is_editable);
            },
            canBeDiscarded() {
                return (this.variation && this.variation.type === 'lesson' && !this.variation.assigned_ts);
            },
            hideMuteButton() {
                return this.question.repeatProgress === 'new';
            }
        },
        data() {
            return {
                open: false,
                closeTimeout: null
            };
        },
        methods: {
            openDropdown() {
                clearTimeout(this.closeTimeout);
                this.open = true;
            },
            closeDropdown() {
                this.open = false;
                clearTimeout(this.closeTimeout);
            },
            closeDropdownDelayed() {
                this.closeTimeout = setTimeout(() => {
                    this.closeDropdown();
                }, 250);
            },
            openReportModal() {
                this.closeDropdown();
                EventBus.$emit('guess:feedback-modal-open');
            },
            openHotkeysModal() {
                this.closeDropdown();
                EventBus.$emit('guess:hotkeys-modal-open');
            },
            muteWord() {
                this.closeDropdown();
                this.$emit('mute-word');
            },
            toggleFavouriteWord() {
                this.closeDropdown();
                if (this.wordIsFavourite) {
                    this.$emit('un-favourite-word');
                } else {
                    this.$emit('favourite-word');
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "~Styles/colors";
    @import "~Styles/mixins";

    div.card-more-dropdown {
        width: pxToRem(28);
        height: pxToRem(28);
        position: relative;
        user-select: none;

        svg {
            circle {
                transition: fill 200ms ease;
            }
        }
        svg.transparent {
            circle {
                fill: transparent;
            }
        }
        &:hover {
            cursor: pointer;
            svg.transparent {
                circle {
                    fill: $colorBackgroundGray;
                }
            }
        }

        div.dropdown {
            display: flex;
            flex-direction: column;
            position: absolute;
            right: 0;
            top: pxToRem(30);
            @include elevated;
            background-color: #fff;
            z-index: 100;
            min-width: pxToRem(250);
            body[data-interface-language="ar"] & {
                left: 0;
                right: unset;
            }
            > div.item {
                padding: pxToRem(16);
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: .5rem;
                &:hover {
                    background-color: $colorBackgroundLighter;
                }
            }
            &.fade-enter-active, &.fade-leave-active {
                transition: opacity 250ms;
            }
            &.fade-enter, &.fade-leave-to {
                opacity: 0;
            }
        }
    }
</style>
